<template>

  <CostiPratiche />

</template>

<script>
import CostiPratiche from '../components/pratiche/CostiPratiche.vue'

export default {
  components: {
    CostiPratiche

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
